'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-define-property/node_modules/function-bind/index.js
// module id = 801
// module chunks = 0 15 16 17 18